import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Service } from './delete-restore.service';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../../common/global-variables';
import { DataProtectionVariables } from '../../../dataprotection-common/dataprotection-variables';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'delete-restore',
  providers: [
    Service, TranslateService
  ],
  styles: [require('./delete-restore.scss')],
  template: require('./delete-restore.html')
})

export class DeleteRestore {
  @Input('isVisible') isVisible: boolean;
  @Input('mode') mode: string;
  @Input('selectedEntity') selectedEntity;
  @Output('onRequestStatusChange') emitter = new EventEmitter();

  private subscribeHandler;
  private active: boolean = true;
  private vmName = '';
  private vcHost = '';

  private isRequestPending: boolean = false;
  private emitData = {
    'status': '',
  };

  constructor(public service: Service, private translate: TranslateService) {
    translate.use(GlobalVariables.LOCALE);
  }

  onSubmit() {
    this.isRequestPending = true;
    this.emitData.status = 'pending';
    this.emitter.emit(this.emitData);
    switch(this.mode){
      case DataProtectionVariables.RESTORE_MODES['VM']:
        this.deleteRestorePointsVm();
        break;
      case DataProtectionVariables.RESTORE_MODES['DELETED_VM']:
        this.deleteRestorePointsDeletedVm();
        break;
      default :
        this.deleteRestorePointsVm();
    }
  }

  onCancelButtonClicked() {
    this.emitter.emit();
  }

  //Life Cycle Hooks
  ngOnInit() {
  }

  ngOnChanges(changes) {
    if ( changes && changes.selectedEntity ) {
        this.vmName = (this.selectedEntity.name) ? this.selectedEntity.name : '';
        this.vcHost = (this.selectedEntity.vcHost) ? this.selectedEntity.vcHost : '';
    }
  }

  ngAfterViewInit() {
  }

  ngOnDestroy() {
    if(this.subscribeHandler) this.subscribeHandler.unsubscribe();
  }

  deleteRestorePointsVm() {
    if(this.selectedEntity && this.selectedEntity.entity_id && this.selectedEntity.entity_id !== '' &&
      this.selectedEntity.vcenter_instanceId && this.selectedEntity.vcenter_instanceId !== '') {
      this.subscribeHandler = this.service.deleteRestorePointsVm(this.selectedEntity.entity_id, this.selectedEntity.vcenter_instanceId)
        .subscribe(
          res => {
            this.handleSuccess();
          },
          error => this.handleError(error),
          () => {}
        );
    }
    else{}
  }

  deleteRestorePointsDeletedVm() {
    if(this.selectedEntity && this.selectedEntity.entity_id && this.selectedEntity.entity_id !== '' &&
      this.selectedEntity.vcenter_instanceId && this.selectedEntity.vcenter_instanceId !== '') {
      this.subscribeHandler = this.service.deleteRestorePointsDeletedVm(this.selectedEntity.entity_id, this.selectedEntity.vcenter_instanceId)
        .subscribe(
          res => {
            this.handleSuccess();
          },
          error => this.handleError(error),
          () => {}
        );
    }
    else{}
  }

  handleSuccess() {
    this.isRequestPending = false;
    this.emitData.status = 'success';
    this.emitter.emit(this.emitData);
  }

  handleError(error) {
    this.isRequestPending = false;
    this.emitData.status = 'error';
    this.emitter.emit(this.emitData);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vc/common-ops/delete-restore/delete-restore.component.ts